const initialState = {
    siteList: [],
    totalSitesCount: 0,
    hierarchyData: []
};

const siteReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'SITE_LIST': {
            return {
                ...state,
                siteList: action.payload.sites,
                totalSitesCount: action.payload.totalCount || 0,
            };
        }
        case 'HIERARCHY_DATA': {
            let hierarchyData = [];
            hierarchyData.push(action.payload);
            return {
                ...state,
                hierarchyData
            };
        }
        case "LOGOUT":
            return initialState;
        default:
            return state;
    }
};

export default siteReducer;